<br/>
<div class="responsiveFlex">
    <div>
        <app-inactividad-card [estado]="estado" [alumnoId]="alumnoId"></app-inactividad-card>
        <app-disable [estado]="estado" [usuarioId]="usuarioId" [motivoBaja]="motivoBaja "></app-disable>
    </div>
    <app-status-history [alumnoId]="alumnoId"></app-status-history>
</div>

